import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
  WritableSignal,
  afterNextRender,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSliderModule } from '@angular/material/slider';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { SearchResultUiService } from '../../services/search-result-ui.service';
import { CommentsFilterComponent } from '../filters/comments-filter/comments-filter.component';
import { LabelsFilterComponent } from '../filters/labels-filter/labels-filter.component';
import { PriceFilterComponent } from '../filters/price-filter/price-filter.component';
import { ResidenceFilterComponent } from '../filters/residence-filter/residence-filter.component';
import { StarsFilterComponent } from '../filters/stars-filter/stars-filter.component';
import { WebengageService } from '@core/services/webengage.service';
import { WINDOW } from '../../search-result.module';
import { TypeOfLocationComponent } from '../filters/type-of-location/type-of-location.component';
import { AccommodationFacilitiesComponent } from '../filters/accommodation-facilities/accommodation-facilities.component';
import { RulesFilterComponent } from '../filters/rules-filter/rules-filter.component';

@Component({
  selector: 'iho-side-filters',
  templateUrl: './side-filters.component.html',
  styleUrls: ['./side-filters.component.scss'],
  standalone: true,
  //changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatRippleModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSliderModule,
    TypeOfLocationComponent,
    AccommodationFacilitiesComponent,
    LabelsFilterComponent,
    StarsFilterComponent,
    PriceFilterComponent,
    CommentsFilterComponent,
    ResidenceFilterComponent,
    RulesFilterComponent
  ],
})
export class SideFiltersComponent implements OnInit {
  private _dataSource: any[] = [];

  @Input() set dataSource(value: any[]) {
    const order = ['labels', 'price', 'grades', 'reviews', 'types', 'rules', 'facilities'];
    // sort the dataSource array based on the order array
    this._dataSource = [...(value || [])].sort((a: any, b: any) => {
      const indexA = order.indexOf(a.Key);
      const indexB = order.indexOf(b.Key);
      return indexA - indexB;
    });
  }

  get dataSource(): any[] {
    return this._dataSource;
  }

  @Input() activeIndex?: any = undefined;
  @Output() toggleDrawerFilters = new EventEmitter();
  @Output() reseSideFilters = new EventEmitter();
  @ViewChild('backdrop', { static: false }) backdrop!: ElementRef;
  showRemoveBtn = false;
  selectedFilterCount: number = 0;
  @Output() FilterCountEmitter = new EventEmitter();
  Filters: string[] = [];
  private searchBoxService = inject(SearchBoxService);
  private renderer = inject(Renderer2);
  route = inject(ActivatedRoute);
  router = inject(Router);
  searchUiService = inject(SearchResultUiService);
  showPriceFilter = signal(true);
  iosDevice = signal(false);
  _isOpen = false;
  isShowFilters = false;
  setParams: any;
  expanded = signal(true);
  reset = signal(false);
  accommodation = computed(() => this.searchBoxService.accommodation());
  itemsPush: any = [];
  _maxValue: WritableSignal<number> = signal(0);
  _minValue: WritableSignal<number> = signal(0);

  activeFilters: Record<string, string> = {};
  nullFilters = {
    minPrice: null,
    maxPrice: null,
    labels: null,
    types: null,
    grades: null,
    reviews: null,
    labelsAccomodate: null,
    hotelTypes: null,
    hotelStyles: null,
    facilities: null,
    rules: null,
  };
  filterLabels: string[] = ['reviews', 'grades', 'types', 'labels', 'minPrice', 'maxPrice', 'rules', 'facilities'];
  filterLabelsEcologe: string[] = [
    'labelsAccomodate',
    'facilities',
    'hotelStyles',
    'hotelTypes',
    'minPrice',
    'maxPrice',
  ];
  reviews = [];
  grades = [];
  types = [];
  labels = [];
  location = [];
  facilities = [];
  minPrice = '';
  maxPrice = '';
  rules = [];
  csrStatus = signal(false);

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(WINDOW) private window: Window,
    private webengageService: WebengageService
  ) {
    effect(() => {
      if (this.searchBoxService.showFiltersSideNav()) this.toggleNav();
    });

    afterNextRender(() => {
      this.iosDevice.set(/iPhone/.test(this.window.navigator.userAgent));
    });
  }
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.csrStatus.set(true);
    }
   this.countFilters();
  }
  countFilters() {
     this.selectedFilterCount = 0;
    const params = this.route.snapshot.queryParams;
    this.Filters = [];

    Object.entries(params).forEach((param: any) => {
      if (this.accommodation() == 'ecolodge') {
        this.filterLabelsEcologe.forEach((label) => {
          if (param[0] == label && param[1].length){
            this.showRemoveBtn = true;
            this.Filters.push(param[0]);
            this.selectedFilterCount++; 
            this.FilterCountEmitter.emit(this.selectedFilterCount);
          } 
        });
      } else {
        this.filterLabels.forEach((label) => {
          if (param[0] == label && param[1].length){
            this.showRemoveBtn = true;
            this.selectedFilterCount++;
            this.FilterCountEmitter.emit(this.selectedFilterCount);
            this.Filters.push(param[0]);
          } 
        });
      }
    });
    if(this.Filters.length == 0){
      this.showRemoveBtn = false;
      this.selectedFilterCount = 0;
      this.FilterCountEmitter.emit(this.selectedFilterCount);
    }
  }


  toggleNav() {
    this.isShowFilters = !this.isShowFilters;

    if (this.isShowFilters) {
      this.createRecaptchaContainer();
      this.renderer
        .selectRootElement('#backdrop', true)
        .addEventListener('click', this.onClickRemoveSide.bind(this));
    } else {
      this.renderer.selectRootElement('#backdrop').remove();
      this.renderer.removeClass(document.body, 'side-open');
      this._isOpen = !this._isOpen;
      if (isPlatformBrowser(this.platformId)) {
        this.window.onscroll = function () { };
      }
      this.searchBoxService.showFiltersSideNav.set(false);
    }
  }

  createRecaptchaContainer() {
    const backDrop = this.renderer.createElement('div');

    this.renderer.addClass(document.body, 'side-open');
    this.renderer.setProperty(backDrop, 'id', 'backdrop');
    this.renderer.appendChild(document.body, backDrop);

    return backDrop;
  }

  onClickRemoveSide() {
    this.renderer.selectRootElement('#backdrop').remove();
    this.renderer.removeClass(document.body, 'side-open');
    this.isShowFilters = !this.isShowFilters;
    if (isPlatformBrowser(this.platformId)) {
      this.window.onscroll = function () { };
    }
    this.searchBoxService.showFiltersSideNav.set(false);
  }



  MinValue(ev: any) {
    this.minPrice = ev;
    this.getDataForFilters(ev, 'minPrice');
  }

  MaxValue(ev: any) {
    this.maxPrice = ev;
    this.getDataForFilters(ev, 'maxPrice');
  }

  getDataForFilters(val: any, typeFilter: string) {
    this.webengageService.trackIntrack('Select-Filter', {
      maxPrice: this.minPrice,
      minPrice: this.maxPrice,
      starRating: this.grades.join(',').toString(),
      review: this.reviews.join(',').toString(),
      accommodationType: this.types,
      destination: this.searchUiService.cityName,
      labels: this.labels,
    });
    this.searchUiService.resetPlpResults();

    this.activeFilters = {
      ...this.activeFilters,
      page: 1,
      [typeFilter]: val.toString(),
    };
  


 
   this.showRemoveBtn = true;
  }

  setFilters(action = 'set') {
    const currentParams = { ...this.route.snapshot.queryParams, ...this.activeFilters };
    if (this.accommodation() == 'ecolodge') {
      delete currentParams['page'];
    }

    if (Object.keys(this.activeFilters).length) {
      this.router.navigate([], {
        queryParams: currentParams,
        relativeTo: this.route,
        // queryParamsHandling: 'merge',
      });
    } else if (action == 'removeAll') {
      this.router.navigate([], {
        queryParams: this.nullFilters,
        relativeTo: this.route,
        queryParamsHandling: 'merge',
      });
    }
    setTimeout(() => {
      this.countFilters();
    }, 100);
    this.toggleNav();
  }

  removeAllFilters() {
    this.activeFilters = {};
    this.setFilters('removeAll');

    this.showPriceFilter.set(false);

    this.reseSideFilters.emit();

    if (isPlatformBrowser(this.platformId)) this.window.onscroll = function () { };
    setTimeout(() => {
      this.showPriceFilter.set(true);
      this.selectedFilterCount = 0;
      this.FilterCountEmitter.emit(this.selectedFilterCount);
    }, 100);
  }


  checkedItemsEmit(obj: any) {
    switch (obj.key) {
      case 'types':
        this.types = obj.value;
        this.getDataForFilters(obj.value, this.accommodation() == 'ecolodge' ? 'hotelTypes' : 'types');
        break;
      case 'hotelStyles':
        this.location = obj.value;
        this.getDataForFilters(obj.value, 'hotelStyles');
        break;
      case 'labels':
        this.labels = obj.value;
        this.getDataForFilters(obj.value, this.accommodation() == 'ecolodge' ? 'labelsAccomodate' : 'labels');
        break;
      case 'reviews':
        this.reviews = obj.value;
        this.getDataForFilters(obj.value, 'reviews');
        break;
      case 'grades':
        this.grades = obj.value;
        this.getDataForFilters(obj.value, 'grades');
        break;
      case 'facilities':
        this.facilities = obj.value;
        this.getDataForFilters(obj.value, 'facilities');
        break;
      case 'rules':
        this.rules = obj.value;
        this.getDataForFilters(obj.value, 'rules');
          break;
    }


  }
}
